import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CurrentCruiseForShipService {
  busSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public GetCurrentCruiseForShip(shipCode: string): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const CurrentCruiseForShipInfo: JSON = <JSON>(<unknown>{
      shipCode: shipCode,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetCurrentCruiseForShip',
      JSON.stringify(CurrentCruiseForShipInfo),
      { headers: headers }
    );
  }
}
